export interface HealthInsurance {
	id: number
	health_insurance_id?: number
	name: string
	acronym?: string
	address?: string
	province?: number
	phone?: string
	email?: string
	web?: string
	is_prepaid?: boolean
}